
export default {
  data() {
    return {
      isMounted: false,
    };
  },
  props: {
    post: {
      type: [Array, Object],
      required: true,
    },
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    returnShowDots(id) {
      var showDots = false;

      if (this.isMounted) {
        const el = document.getElementsByClassName("post-info");
        const categoryList = document.getElementById(id);

        if (el && el.length && el[0] && categoryList) {
          if (categoryList.offsetWidth > el[0].offsetWidth - 32) {
            showDots = true;
          }
        }
      }

      return showDots;
    },
  },
};
